import apiClient from "services/axios";
import { parseParams } from "utils";

const API = {
  list: "/api/v1/buckets",
  getData: "/api/v1/buckets",
  clearRange: "/api/v1/buckets/clear",
};

export const list = async (filter) => {
  const response = await apiClient.get(API.list, {
    params: filter,
    paramsSerializer: (params) => parseParams(params),
  });
  if (response) {
    return response.data;
  }
  return false;
};
export const getData = async (bucketId) => {
  const response = await apiClient.get(`${API.getData}/${bucketId}`);
  if (response) {
    return response.data;
  }
  return false;
};

export const clearRange = async (body) => {
  const response = await apiClient.post(API.clearRange, body);
  if (response) {
    return response.data;
  }
  return false;
};
